import { render, staticRenderFns } from "./BaseErrorBlock.vue?vue&type=template&id=386e1864&"
import script from "./BaseErrorBlock.vue?vue&type=script&lang=js&"
export * from "./BaseErrorBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports